module.exports = __webpack_public_path__ + "static/media/hexagan-missing.e4488698.svg";